export default "__VITE_PUBLIC_ASSET__b2e4ea52__"